export enum GroupTermFunctionTypeEnum {
    Action = "action",
    Object = "object",
    Other = "Other"
}